import { MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as DownloadIcon } from "../../assets/icons/NewIcons/IconDownload.svg";
import { ReactComponent as InprogressIcon } from "../../assets/icons/NewIcons/inProgressIcon.svg";
import { ReactComponent as FailedIcon } from "../../assets/icons/NewIcons/failedIcon.svg";
import { ReactComponent as ApprovedIcon } from "../../assets/icons/NewIcons/approvedIcon.svg";
import ReactTable from "../../components/ReactTable/ReactTable";
import { dollarUS, formatDateTime } from "../../utilities/formatters";
import axios from "axios";
import { tokenConfig } from "../../store/reducers/tokenReducer";
import { myStore } from "../..";
import Loader from "../../reusableComponents/Loader";
// import Loader from "../../reusableComponents/Loader";

const PayoutTable = () => {
  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  useEffect(() => {
    setOpen(loader);
  }, []);
  const StatFormatter = (data) => {
    const Stat = data.toLowerCase();
    const classList = Stat.includes("approved")
      ? "StatusPassed"
      : Stat.includes("interview")
      ? "StatusProgress"
      : Stat.includes("new")
      ? "StatusNew"
      : "rejected";

    return <div className={`Status ${classList}`}>{data}</div>;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "#Id",
        accessor: "id", // accessor is the "key" in the data
      },
      {
        Header: () => (
          <>
            Payout Type{" "}
            {/* <Select className="payoutTableSelectorBox">
              <MenuItem className="payoutTableSelectorBox" value="">
                1
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                2
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                3
              </MenuItem>
            </Select> */}
          </>
        ),
        accessor: "type",
        Cell: ({ value }) => <span style={{ color: "#0d56eb" }}>{value}</span>,
      },
      {
        Header: () => (
          <>
            Requested on
            {/* <Select className="payoutTableSelectorBox">
              <MenuItem className="payoutTableSelectorBox" value="">
                1
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                2
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                3
              </MenuItem>
            </Select> */}
          </>
        ),
        accessor: "created_at",
        Cell: ({ value }) => formatDateTime(value),
      },
      {
        Header: () => (
          <>
            Method{" "}
            {/* <Select className="payoutTableSelectorBox">
              <MenuItem className="payoutTableSelectorBox" value="">
                1
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                2
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                3
              </MenuItem>
            </Select> */}
          </>
        ),
        accessor: "method",
      },
      {
        Header: () => (
          <>
            Status{" "}
            {/* <Select className="payoutTableSelectorBox">
              <MenuItem className="payoutTableSelectorBox" value="">
                1
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                2
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                3
              </MenuItem>
            </Select> */}
          </>
        ),
        accessor: "status",


        Cell: ({ value }) => <div>{StatFormatter(String(value))}</div>,
      },
      {
        Header: () => (
          <>
            Amount{" "}
            {/* <Select className="payoutTableSelectorBox">
              <MenuItem className="payoutTableSelectorBox" value="">
                1
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                2
              </MenuItem>
              <MenuItem className="payoutTableSelectorBox" value="">
                3
              </MenuItem>
            </Select> */}
          </>
        ),
        accessor: "amount",
        Cell: ({ value }) => dollarUS(value),
      },
      {
        Header: "Certificate",
        accessor: "invoice",
        Cell: ({ value }) =>
          value ? (
            <a href={value} target="_blank" rel="noreferrer">
              <DownloadIcon className="historyDesk-downloadButton" />
            </a>
          ) : (
            "N/A"
          ),
      },
    ],
    []
  );

  // const { payout_list } = useSelector((state) => state.payout);
  // const data = React.useMemo(() => payout_list, [payout_list]);
  const [payoutList, setPayoutList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPayouts = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `/get/user-payouts/`,
        tokenConfig(myStore.getState)
      );
      setPayoutList(response.data || []);
    } catch (error) {
      console.error("Error fetching payouts:", error);
      setError(error.response?.data?.message || "Failed to fetch payouts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayouts();
  }, []);

  return (
    <div>
      <Loader open={loading} />
      <ReactTable columns={columns || []} data={payoutList || []} />
    </div>
  );
};

export default PayoutTable;
